import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type EmailAuthMutationVariables = Types.Exact<{
  user: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type EmailAuthMutation = { __typename?: 'Mutation', auth?: { __typename?: 'Auth', token?: string | null, type?: string | null, user?: { __typename?: 'User', id: string, name?: string | null, email: string, active: boolean, is_admin: boolean } | null } | null };


export const EmailAuthDocument = gql`
    mutation EmailAuth($user: String!, $password: String!) {
  auth(user: $user, password: $password) {
    token
    type
    user {
      id
      name
      email
      active
      is_admin
    }
  }
}
    `;
export type EmailAuthMutationFn = Apollo.MutationFunction<EmailAuthMutation, EmailAuthMutationVariables>;

/**
 * __useEmailAuthMutation__
 *
 * To run a mutation, you first call `useEmailAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAuthMutation, { data, loading, error }] = useEmailAuthMutation({
 *   variables: {
 *      user: // value for 'user'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useEmailAuthMutation(baseOptions?: Apollo.MutationHookOptions<EmailAuthMutation, EmailAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailAuthMutation, EmailAuthMutationVariables>(EmailAuthDocument, options);
      }
export type EmailAuthMutationHookResult = ReturnType<typeof useEmailAuthMutation>;
export type EmailAuthMutationResult = Apollo.MutationResult<EmailAuthMutation>;
export type EmailAuthMutationOptions = Apollo.BaseMutationOptions<EmailAuthMutation, EmailAuthMutationVariables>;